export const SET_EMPPAGE = '@emp/SET_EMPPAGE';